import {mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  name: 'popupUserAccessDenied',
  //---components
  //---data
  data () {
    return {
    }
  },
  //---hooks
  computed: {
    ...mapGetters({
      isAuthLoading: 'AUTH/isAuthLoading',
      user: 'AUTH/user',
      isHasPTFToken: 'AUTH/isHasPTFToken',
      isAuthError: 'AUTH/isAuthError',
      authSaveRoutes: 'AUTH/authSaveRoutes',

      popupStore: 'APP/popupStore',
      isLoaderActive: 'APP/isLoaderActive',
    }),
  },
  //---methods
  methods: {
    ...mapMutations({
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
      popupClose: 'APP/APP_POPUP_CLOSE',
      setAuthError: 'AUTH/AUTH_ERROR_SET',
      setAuthRoutes: 'AUTH/AUTH_ROUTES_SET',
    }),
    ...mapActions({
      createNotifications: 'NOTIFICATIONS/NOTIFICATIONS_CREATE_REQUEST_SET',
      getLogin: 'AUTH/AUTH_LOGIN_ACTION',
    }),
    closePopup() {
      this.popupClose('popupUserAccessDenied');
      if (this.authSaveRoutes && this.authSaveRoutes.from) {
        this.$router.push({name: this.authSaveRoutes.from.name}).catch(err => {});
      } else {
        this.$router.push({name: 'home'});
      }
      this.setAuthRoutes(null);
    },
  }
}